import KeyboardNavigation from '../../grid/keyboardNavigation';
import ExpandButtons from '../../extensions/expandButtons';

export default instance => {
  instance.attachEvent('onGanttRender', () => KeyboardNavigation.onGanttRender());
  instance.attachEvent('onGanttRender', () => {
    if (instance.ganttDataApi.isBase()) {
      ExpandButtons.debouncedUpdatePositions();
    }
  });
  instance.attachEvent('onGanttRender', () => setTimeout(() => {
    instance.callEvent('onUpdateWindowParams');
  }));
};
